(function cascadiaBundleSwap(){
  if(window.cascadiaBundleSwapLoaded) return;
  window.cascadiaBundleSwapLoaded = true;

  const CFG = window.cascadiaConfig || {};
  const BUNDLES = CFG.bundles || [];

  const $body = () =>
    document.querySelector('#CartPageForm') ||
    document.querySelector('.drawer__inner, .cart-drawer__content, [data-cart-drawer] .drawer__cart');

  function moneyFmt(cents){
    const currency = CFG.currency || 'CAD';
    const symbol = { CAD:'$', USD:'$', GBP:'£', EUR:'€', AUD:'$', NZD:'$', CNY:'¥', JPY:'¥' }[currency] || '$';
    return symbol + (cents / 100).toFixed(2);
  }

  function escapeHtml(str){
    const d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  // ── Find a bundle whose full component set is present as individual lines ──
  function findMatchingBundle(cartItems){
    if(!BUNDLES.length) return null;
    for(const bundle of BUNDLES){
      if(!bundle.componentHandles || !bundle.componentHandles.length) continue;
      const bundleAlreadyInCart = cartItems.some(i => i.handle === bundle.bundleHandle);
      if(bundleAlreadyInCart) continue;
      const allPresent = bundle.componentHandles.every(h => cartItems.some(i => i.handle === h));
      if(allPresent) return bundle;
    }
    return null;
  }

  function computeSavings(cart, bundle){
    let individualTotal = 0;
    bundle.componentHandles.forEach(h => {
      const line = (cart.items || []).find(i => i.handle === h);
      if(line) individualTotal += line.price;
    });
    return Math.max(0, individualTotal - bundle.bundlePrice);
  }

  // ── Passive detection banner ──
  async function render(){
    const body = $body();
    if(!body) return;

    let cart;
    try { cart = await window.cascadiaState.getState(); } catch(e){ return; }

    const existing = document.querySelector('#cascadia-bundle-banner');
    const bundle = findMatchingBundle(cart.items || []);

    if(!bundle){
      if(existing) existing.remove();
      return;
    }

    const dismissKey = 'cas-bundle-dismissed-' + bundle.bundleHandle;
    if(sessionStorage.getItem(dismissKey)){
      if(existing) existing.remove();
      return;
    }

    if(existing) return; // already showing — don't rebuild mid-interaction

    const savings = computeSavings(cart, bundle);

    const el = document.createElement('div');
    el.id = 'cascadia-bundle-banner';
    el.style.cssText = 'margin:0 0 12px;box-sizing:border-box;width:100%;';
    el.innerHTML =
      '<div style="padding:14px 16px;background:#f0f7f0;border:1px solid #c8e0c8;border-radius:12px;font-family:Jost,sans-serif;box-sizing:border-box;">' +
        '<div style="display:flex;align-items:center;gap:10px;margin-bottom:8px;">' +
          (bundle.bundleImage ? '<img src="' + bundle.bundleImage + '" style="width:36px;height:36px;border-radius:8px;object-fit:cover;flex-shrink:0;">' : '') +
          '<p style="margin:0;font-size:12.5px;font-weight:500;color:#1e3a20;line-height:1.4;flex:1;">You\'ve got the full ' + escapeHtml(bundle.routineName || bundle.bundleTitle) + ' set' + (savings > 0 ? ' — save ' + moneyFmt(savings) + ' as a bundle' : '') + '</p>' +
        '</div>' +
        '<div style="display:flex;gap:8px;">' +
          '<button type="button" id="cas-bundle-swap-btn" style="flex:1;background:#03593A;color:#faf8f5;border:none;border-radius:999px;padding:9px 14px;font-family:Jost,sans-serif;font-size:12px;font-weight:600;cursor:pointer;">Switch to bundle · ' + moneyFmt(bundle.bundlePrice) + '</button>' +
          '<button type="button" id="cas-bundle-dismiss-btn" style="background:none;border:none;color:#6b5c4a;font-size:12px;cursor:pointer;padding:9px 10px;">No thanks</button>' +
        '</div>' +
      '</div>';

    const scrollable = body.querySelector('.drawer__scrollable');
    const products = body.querySelector('[data-products]');
    if(scrollable && products){
      scrollable.insertBefore(el, products);
    } else {
      const ladder = body.querySelector('#cascadia-ladder');
      const header = body.querySelector('#cas-drawer-header');
      if(ladder){
        ladder.insertAdjacentElement('afterend', el);
      } else if(header){
        header.insertAdjacentElement('afterend', el);
      } else {
        body.prepend(el);
      }
    }

    el.querySelector('#cas-bundle-dismiss-btn').addEventListener('click', function(){
      sessionStorage.setItem(dismissKey, '1');
      el.remove();
    });

    el.querySelector('#cas-bundle-swap-btn').addEventListener('click', async function(){
      const btn = el.querySelector('#cas-bundle-swap-btn');
      btn.disabled = true;
      btn.textContent = 'Switching…';
      try {
        const freshCart = await window.cascadiaState.refresh();
        for(const handle of bundle.componentHandles){
          const line = freshCart.items.find(i => i.handle === handle);
          if(!line) continue;
          if(line.quantity > 1){
            await window.cascadiaState.updateQuantity(line.key, line.quantity - 1);
          } else {
            await window.cascadiaState.removeFromCart(line.key);
          }
        }
        await window.cascadiaState.addToCart(bundle.bundleVariantId, 1);
        el.remove();
      } catch(e){
        console.warn('[cascadia] bundle swap failed', e);
        btn.disabled = false;
        btn.textContent = 'Try again';
      }
    });
  }

  let scheduled = false;
  function scheduleRender(){
    if(scheduled) return;
    scheduled = true;
    setTimeout(function(){
      scheduled = false;
      render().catch(function(){});
    }, 200);
  }

  document.addEventListener('cascadia:cart-changed', scheduleRender);
  document.addEventListener('ajaxProduct:added', scheduleRender);
  document.addEventListener('cart:updated', scheduleRender);

  // ── "Add routine to cart" override — adds the bundle directly when one exists ──
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#routine-add-btn');
    if(!btn || btn.classList.contains('is-complete')) return;

    var routineName = btn.getAttribute('data-routine-name');
    var bundle = BUNDLES.find(function(b){ return b.routineName === routineName; });
    if(!bundle) return; // no bundle mapped — let the section's own individual-add logic run

    e.preventDefault();
    e.stopImmediatePropagation();

    var addBtnText = document.getElementById('routine-add-btn-text');
    var originalText = addBtnText ? addBtnText.textContent : '';
    if(addBtnText) addBtnText.textContent = 'Adding…';
    btn.style.opacity = '0.6';
    btn.style.pointerEvents = 'none';

    window.cascadiaState.addToCart(bundle.bundleVariantId, 1)
      .then(function(){
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
      })
      .catch(function(){
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
        if(addBtnText) addBtnText.textContent = originalText;
      });
  }, true);

  render();
})();